import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-light-svg-icons';
import { AccionIcon, Tab } from './tab.interface';
import { IconActionComponent } from '../icon-action/icon-action.component';

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, IconActionComponent],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class TabComponent {
  @Input() tabTemplates!: { [key: string]: any };
  @Input() tituloHeader:string = "";
  @Input() separador:boolean = false;
  @Input() activeTab:string = "";
  @Input() accionIconLeft: AccionIcon[] = [
    {
      icon: faQuestionCircle,
      titleToltip: 'titulo toltips',
      positionToltip: 'bottom-right',
      name: "",
      dropdown: {
        isDropDown:true,
        opciones:[]
      }
    }
  ];
  @Input() accionIconRight: AccionIcon[] = [
    {
      icon: faQuestionCircle,
      titleToltip: 'titulo toltips',
      positionToltip: 'bottom-right',
      name: "",
      dropdown: {
        isDropDown:true,
        opciones:[]
      }
    }
  ];
  @Input() tabs:Tab[] = [
    { name: 'tab1', label: 'Tab 1' },
    { name: 'tab2', label: 'Tab 2' },
    { name: 'tab3', label: 'Tab 3' }
  ];

  @Output() clickIcon = new EventEmitter<any>();
  @Output() clickTab = new EventEmitter<any>();

  ngOnInit(): void {  
    //this.activeTab = this.tabs[0].name;
  }

  ngOnChanges(changes:SimpleChanges): void {
  } 

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    this.clickTab.emit(tabName);
  }

  clickPress(evt: Event){
    this.clickIcon.emit(evt);
  }

  accionBtn(event:any){

  }

}
